
function DataShareGuard(to, from, next) {
    next()
}

export default DataShareGuard
